import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import * as urlUtils from 'js/utils/url.util';
import { storageService } from 'js/services/storage.service';
import { useNavigate, useRemoveQueryParams } from 'js/hooks/navigate';
import { useIsAllowedToRedirect } from 'js/hooks/useIsAllowedToRedirect';

export const useRedirectToAfterLoginURL = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const removeQueryParams = useRemoveQueryParams();
    const isAllowedToRedirect = useIsAllowedToRedirect();

    return useCallback((afterRegisterLogin = false) => {
        const { afterLoginUrl: afterLoginUrlParam } = urlUtils.getURLParams(location.search);
        const afterLoginUrlStored = storageService.session.getItem('afterLoginUrl');
        const afterLoginUrl = afterLoginUrlParam || afterLoginUrlStored;

        if (!afterLoginUrl || afterRegisterLogin) {
            return;
        }

        removeQueryParams(['afterLoginUrl']);
        storageService.session.removeItem('afterLoginUrl');

        if (isAllowedToRedirect(afterLoginUrl)) {
            navigate(afterLoginUrl, location.state);
        }
    }, [navigate, removeQueryParams, isAllowedToRedirect, location]);
};
